import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import Loader from '../../utils/Loader'
import TaxValuesForm from './TaxValuesForm'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'
import { getLocations, getProvinces } from '../../../store/actions/locations'

class AdminTaxes extends Component {
    constructor(props){
        super(props)
        this.state = {
            country: '',
            province: '',
            updateLoading: false,
            updateSuccess: '',
            errors: {}
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Taxes')
    }

    componentDidMount(){
        this.props.getLocations()
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.default_country !== null && this.state.country === ''){
            this.setState({
                country: nextProps.default_country
            })
        }
    }

    updateSelectedCountry = (country) => {
        this.setState({
            country: country.id,
            province: ''
        }, () => this.props.getProvinces(this.state.country))
    }

    updateSelectedProvince = (province) => {
        this.setState({
            province: province.abbreviation
        })
    }

    handleFormStateUpdates(updateObjects){
        updateObjects.map(obj =>
            this.setState({
                [obj.id]: obj.value
            })
        )
    }

    render() {
        const { countries, provinces, locationsError, locationsLoading } = this.props
        const { errors } = this.state

        return (
            <div>
                <h1>Taxes</h1>

                {locationsError ? (
                    <div className="error top-margin">{locationsError}</div>
                ) : (
                    locationsLoading ? <div className="pt2 pb2"><Loader /></div> :
                    
                    <div>
                        {this.state.updateSuccess && <div className="success msg_animate">{this.state.updateSuccess}</div>}
                        
                        <div className="floated-field-container">
                            <div className="form-field no-label-field half-field">
                                <label htmlFor="country">Country:</label>
                                
                                {!!errors.country &&
                                    <div className="error msg_animate">{errors.country}</div>
                                }
                                
                                <Select
                                    name={`country`}
                                    placeholder='Country'
                                    value={this.state.country}
                                    onChange={(selection) => this.updateSelectedCountry(selection)}
                                    clearable={false}
                                    valueKey='id'
                                    labelKey='title'
                                    options={countries}
                                    disabled={this.state.updateLoading}
                                />
                            </div>

                            <div className="form-field no-label-field half-field">
                                <label htmlFor="province">Province:</label>
                                
                                {!!errors.province &&
                                    <div className="error msg_animate">{errors.province}</div>
                                }

                                <Select
                                    name={`province`}
                                    placeholder={this.state.country === 'CA' ? 'Province' : 'State'}
                                    value={this.state.province}
                                    onChange={(selection) => this.updateSelectedProvince(selection)}
                                    clearable={false}
                                    valueKey='abbreviation'
                                    labelKey='name'
                                    options={provinces}
                                    disabled={this.state.updateLoading}
                                />
                            </div>
                        </div>
                        
                        {this.state.country && this.state.province &&
                            <TaxValuesForm country={this.state.country} province={this.state.province} handleUpdates={this.handleFormStateUpdates.bind(this)} />
                        }
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, getLocations, getProvinces })(AdminTaxes)



// WEBPACK FOOTER //
// ./src/components/admin/taxes/AdminTaxes.js